import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AssessmentState, AssessmentWrapperModel } from '../../models/assessment-wrapper.model';
import { AssessmentService } from '../../services/assessment-service/assessment.service';

const allowedAssessmentStates: AssessmentState[] = [AssessmentState.STARTED, AssessmentState.COMPLETED];

export const assessmentReadonlyGuard: CanActivateFn = () => {
  const assessmentService: AssessmentService = inject(AssessmentService);
  const router: Router = inject(Router);

  const assessmentId = assessmentService.getCurrentAssessmentWrapperId();
  if (!assessmentId) {
    return router.createUrlTree(['/initial-information']);
  }
  return assessmentService.get(assessmentId).pipe(
    map((assessmentWrapper: AssessmentWrapperModel) => allowedAssessmentStates.includes(assessmentWrapper.state)),
    map(result => result || router.createUrlTree(['/initial-information']))
  );
};
